import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Image, PageSection, Proportion } from '@gik/ui';
import { getAssetsUrl } from '@gik/core/utils/LinkUtils';

const blockName = 'hero-computer';

export default function HeroComputer() {
  const bem = bemBlock(blockName);

  return (
    <PageSection noPad className={bem()}>
      <div className={bem('container')}>
        <Image
          {...{
            className: bem('image'),
            asBackground: true,
            src: `${getAssetsUrl()}homepage/img/hero-comp.png`,
            proportion: new Proportion(1142, 500),
          }}
        />
      </div>
    </PageSection>
  );
}
